module.exports = __webpack_public_path__ + "media/images/icons/empowerment-2de5a9c25f426e9f8fd31b91e3df2411.png";